import { withDependencies, named } from '@wix/thunderbolt-ioc'
import type { Experiments, IPageWillMountHandler } from '@wix/thunderbolt-symbols'
import { PageFeatureConfigSymbol, ExperimentsSymbol } from '@wix/thunderbolt-symbols'
import type { BuilderContextProvidersPageConfig, ContextProviderLoader } from './types'
import { name, ContextProviderLoaderSymbol } from './symbols'

export const BuilderContextProvidersPageWillMountHandler = withDependencies(
	[named(PageFeatureConfigSymbol, name), ContextProviderLoaderSymbol, ExperimentsSymbol],
	(
		pageFeatureConfig: BuilderContextProvidersPageConfig,
		contextProviderLoader: ContextProviderLoader,
		experiments: Experiments
	): IPageWillMountHandler => {
		return {
			name: 'builderContextProvidersLoader',
			pageWillMount: async () => {
				if (!experiments['specs.thunderbolt.contextProviders']) {
					return
				}

				// Load context providers for components with attached contexts
				const contextCompIds = Object.keys(pageFeatureConfig.compIdToContextsMap)
				// Also load function libraries for components with bindings (may not have contexts)
				const bindingCompIds = Object.keys(pageFeatureConfig.compIdToBindingMap)
				const allCompIds = [...new Set([...contextCompIds, ...bindingCompIds])]

				await Promise.all(allCompIds.map((compId) => contextProviderLoader.retrieveContextProviders(compId)))
			},
		}
	}
)
